function inputTel(id) {

    if ( id.length ) {
        id.mask("+7 (999) 999-99-99", {autoclear: false});
    }
}